import { GenIcon } from '~/libs/icons/IconBase';

export const IconSIgn = GenIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.4649 3.18013C15.5435 2.94521 15.6681 2.7283 15.8315 2.54205C15.9948 2.35579 16.1936 2.20394 16.4162 2.09533C16.6389 1.98673 16.8809 1.92356 17.1283 1.9095C17.3756 1.89544 17.6232 1.93078 17.8568 2.01346C18.0903 2.09613 18.305 2.22448 18.4884 2.39103C18.6718 2.55757 18.8202 2.75897 18.9249 2.98347C19.0296 3.20797 19.0886 3.45108 19.0983 3.69861C19.1081 3.94614 19.0684 4.19314 18.9817 4.42518L15.2016 15.1023L12.8207 16.2381L11.6848 13.8572L15.4649 3.18013Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15.5564 4.19755L18.5317 5.43541" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M7.54669 8.05117C7.01471 6.94281 5.70936 5.40036 3.88824 6.45638C3.16819 6.87392 2.19139 7.71288 1.50209 9.21111C0.812798 10.7093 0.282855 15.1977 2.4565 16.8957C3.19891 17.4756 4.81079 18.4039 5.95598 15.736C6.06202 15.5427 6.27411 14.7211 6.75147 14.576C7.22883 14.4309 7.54681 14.866 7.70588 15.8807C7.86495 16.7507 8.34215 18.3166 8.97843 17.6206C9.77377 16.7507 9.93284 16.7507 10.251 16.7507C10.5691 16.7507 11.0463 17.1857 11.6826 18.4906C11.7886 18.6839 12.0644 19.0416 12.3189 18.9256"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>,
);

export const IconStamp = GenIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.875 15.4998V14.1194C16.875 12.6132 15.654 11.3921 14.1477 11.3921H11L12.8387 5.99975C13.066 4.86336 12.7023 2.59058 9.42957 2.59058C6.15684 2.59058 5.7932 4.86336 6.02048 5.99975L7.71431 11.3921H4.60227C3.09604 11.3921 1.875 12.6132 1.875 14.1194V15.4998C1.875 16.2529 2.5 16.7166 3.23864 16.7166H15.5114C16.2645 16.7166 16.875 16.2529 16.875 15.4998Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 19H16" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>,
);

export const IconDelete = GenIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M4.16666 5.83337H15L14.1667 16.6667H4.99999L4.16666 5.83337Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M7.69232 8.33337L8.14104 14.1667"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.282 8.33337L10.8333 14.1667"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.5 5.83337H16.6667" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <path
      d="M13.3333 5.83337V4.16671C13.3333 3.70647 12.9602 3.33337 12.5 3.33337H6.66668C6.20644 3.33337 5.83334 3.70647 5.83334 4.16671V5.83337"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>,
);
